export const logoutRoute = '/logout'